export default "__VITE_ASSET__Dq9$RTHl__"